module.exports = __webpack_public_path__ + "img/levels-banner.7182ea0c.png";